import { UserRole } from ".";

export default interface IContatto {
    Id: number;
    Id_Anagrafica: number;
    Ruolo: UserRole;
    Nome: string;
    Cognome: string;
    Telefono: string | null;
    Email: string | null;
    Creation: string;
    Timestamp: string;
}

export const exampleContatto: IContatto = {
    Id: 0,
    Id_Anagrafica: 0,
    Ruolo: UserRole.NONE,
    Nome: '',
    Cognome: '',
    Telefono: null,
    Email: null,
    Creation: '',
    Timestamp: '',
};